import React from 'react';

const FlexibleInput = ({
  placeholder,
  type = 'text',
  value,
  onChange,
  onBlur,
  onKeyPress,
  icon: Icon,
  iconClass = '',
  className = '',
  error = '',
  touched = false,
  disabled = false,
  required = false,
}) => {
  return (
    <div className="relative w-full">
      <div className="relative">
        {Icon && (
          <div className="absolute left-4 top-4 z-10 pointer-events-none">
            <Icon className={`h-5 w-5 ${iconClass}`} />
          </div>
        )}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onKeyPress={onKeyPress}
          disabled={disabled}
          required={required}
          className={`
            w-full border rounded-xl
            ${Icon ? 'pl-12 pr-4' : 'px-4'} py-4
            focus:outline-none focus:ring-2 focus:border-transparent
            transition-all duration-300
            ${
              error && touched
                ? 'border-red-400 focus:ring-red-400/20 bg-red-50/5'
                : 'focus:ring-2'
            }
            ${disabled ? 'opacity-50 cursor-not-allowed bg-gray-700/50' : ''}
            ${
              className ||
              'bg-gray-800/50 border-gray-600 text-white placeholder-gray-400 focus:ring-green-500/20 focus:border-green-400'
            }
          `}
        />
      </div>
      {error && touched && (
        <p className="mt-2 text-sm text-red-400 flex items-center">
          <svg
            className="w-4 h-4 mr-1 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};

export default FlexibleInput;
